<template>
  <div>
    <!-- 产品分类列表 - 筛选 -->
    <div class="all-center-box">
      <div class="w-1500">
        <div class="product-screen w-100">
          <div class="box-info3 w-100 between-center">
            <div class="pull-left">产品列表</div>
            <div class="pull-right between-center">
              <div class="box1">
                <span :class="active == 0 ? 'active' : ''" @click="changeBox(0)"
                  >大图</span
                >
                <span :class="active == 1 ? 'active' : ''" @click="changeBox(1)"
                  >列表</span
                >
              </div>
              <div class="box2">
                <span
                  >共 <i>{{ total }}</i> 件商品</span
                ><span
                  ><i>{{ pageIndex }}</i> / {{ pCount }}</span
                >
              </div>
            </div>
          </div>
          <div class="box-info4 w-100" v-show="active == 0">
            <div
              class="no-content"
              style="display: flex; justify-content: center"
              v-if="total <= 0"
            >
              <img src="../../../static/img/no_data5.png" />
            </div>
            <ul v-else>
              <li
                v-for="(item, index) in goodsList"
                :key="index"
                @click="productDetails(item)"
              >
                <a>
                  <i
                    ><img
                      :src="
                        item.coverUrl
                          ? item.coverUrl
                          : '../../../static/img/goods_defalut.png'
                      "
                  /></i>
                  <p :title="item.name">{{ item.name }}</p>
                  <span>{{ item.modelNumber || '无' }}</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="box-info5 w-100" v-show="active == 1">
            <div
              class="no-content"
              style="display: flex; justify-content: center"
              v-if="total <= 0"
            >
              <img src="../../../static/img/no_data5.png" />
            </div>
            <table class="table table-bordered" v-else>
              <tr>
                <th width="8%">图例</th>
                <th width="41%">系列名称</th>
                <th width="41%">产品属性</th>
              </tr>
              <tr
                v-for="(item, index) in goodsList"
                :key="index"
                @click="productDetails(item)"
              >
                <td>
                  <a
                    ><img
                      :src="
                        item.coverUrl
                          ? item.coverUrl
                          : '/static/img/goods_defalut.png'
                      "
                  /></a>
                </td>
                <td>
                  <a>{{ item.name }}</a>
                </td>
                <td>{{ item.modelNumber || '无' }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="fanye w-100">
          <div class="pull-right">
            <!-- <ul class="between-center">
							<li><a href="">&lt;</a></li>
							<li><a href="" class="active">1</a></li>
							<li><a href="">2</a></li>
							<li><a href="">3</a></li>
							<li><a href="">4</a></li>
							<li><a href="">5</a></li>
							<li><a href="">6</a></li>
							<li><a href="">&gt;</a></li>
						</ul> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="total"
              :current-page="pageIndex"
              :page-count="pCount"
              @current-change="currentChange"
              v-if="total > 0"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getgoodsList, getCategorList, getCategoryFilterList } from "../../common/http.js";
export default {
  filters: {
    specFormat: function (value) {
      if (value) {
        let str = "";
        if (value.specKeys.length > 0 && value.specInsts.length > 0) {
          str = value.specKeys[0].name + "：" + value.specInsts[0].name;
        }
        return str;
      }
      return "";
    }
  },
  data () {
    return {
      goodsList: [],
      pageIndex: 1,
      pageSize: 28,
      category: "",
      total: 10,
      pCount: 0,
      active: 0,
      categoryId: 0,
      type: '',
      rId: ''
    };
  },
  created () {
    if (this.$route.query) {
      this.type = this.$route.query.type;
      this.rId = this.$route.query.id; // 推荐id
      this.getgoodsList()
      // this.category = this.$route.query;
      // this.categoryId = this.category.obj;
    }
  },
  methods: {
    getgoodsList () {
      if(this.type === 'recommend'){
        getgoodsList({
        recommend: 1,
        pageSize: 28,
        pageIndex: this.pageIndex,
        state: 10
      }).then(res => {
        if (res.result) {
          this.goodsList = res.data.rows;
          this.pCount = res.data.size;
          this.total = res.data.total;
        }
      })
      } else if(this.type === 'category'){
        // this.$message.error('暂未开放');
        // return
        getCategorList({
          id: this.rId,
          pageSize: 28,
          pageIndex: this.pageIndex,
          state: 10
        }).then(res => {
          if (res.result) {
            this.goodsList = res.data.rows.map(item=>{
              return item.eshopGdGoodsTbl2
            });
            this.pCount = res.data.size;
            this.total = res.data.total;
          }
        })
      }
      // let opt = {
      //   categoryId: this.category.obj
      // };
      // // 获取商品列表
      // getgoodsList(opt).then(res => {
      //   if (res.result) {
      //     this.goodsList = res.data.rows;
      //     this.pCount = res.data.size;
      //     this.total = res.data.total;
      //   }
      // });
    },
    changeBox (idx) {
      this.active = idx;
    },
    currentChange (e) {
      this.pageIndex = e;
      this.getgoodsList();
    },
    productDetails (item) {
      let params = {
        uid: item.uid,
        parent: this.category
      };
      this.$router.push({
        name: "productTypeScreen",
        path: "/productTypeScreen",
        query: params
      })
      // const routerJump = this.$router.resolve({
      //   name: "productDetails",
      //   path: "/productDetails",
      //   query: params
      // });

      // window.open(routerJump.href, "_blank", "noopener noreferrer");
    },
    pageJump () {
      this.$router.back();
    },
  }
};
</script>
<style>
.category {
  display: flex;
  border-top: 1px solid #eeeeee;
  padding: 1rem 0;
}
.categorys {
  display: flex;
  align-items: center;
}

.title {
  width: 10%;
  font-size: 0.875rem;
  padding-top: 0.5rem;
  color: #999;
  white-space: nowrap;
}

.category .list {
  margin-right: 4rem;
  margin-bottom: 2rem;
}
.box {
  height: 100%;
  white-space: nowrap;
  color: #999;
  font-size: 0.875rem;
  padding: 0 0.5rem;
}

.list-groups {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/productList.vue